import React from 'react';
import { useBondsTileTabContext } from '@/creditflowresearch/application/Bonds/BondsTileTabContext';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import BondTypes from './BondTypes';

const BondTypesContainer = (props) => {
  const { activeTab, setActiveTab } = useBondsTileTabContext();
  const {
    inventoriesData: { inventories: { totalCount: inventoriesTotalCount } },
  } = useInventoryTableContext();
  const {
    bwicsData: { bwics: { totalCount: bwicsTotalCount } },
  } = useBwicTableContext();

  return (
    <BondTypes
      { ...props }
      isInventoryEmpty={ !inventoriesTotalCount }
      isBwicEmpty={ !bwicsTotalCount }
      activeTab={ activeTab }
      setActiveTab={ setActiveTab }
    />
  );
};

export default BondTypesContainer;
